// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".distribution-settings{display:flex;align-items:center}.distribution-settings label{margin-right:10px;margin-bottom:0}.dropdown button{min-width:100px}.body{font-family:Open Sans,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:13px;color:#3e4855;background-color:inherit!important;line-height:1.42857143}", ""]);
// Exports
module.exports = exports;
